/**
 * AUTO-GENERATED COMPONENT CATALOG
 *
 * Generated by: pnpm run generate-component-catalog
 * Source: @bees-web/nfa-components-react/lib
 * Static: 38 (header/footer — eagerly imported)
 * Dynamic: 129 (lazy-loaded via next/dynamic)
 *
 * Static components are used by the global header/footer (nfa-global) and
 * appear on every page — they are imported eagerly to avoid dynamic-loading
 * overhead for always-needed UI.
 *
 * Dynamic components get their own webpack chunk loaded on demand.
 *
 * DO NOT EDIT MANUALLY — regenerate with: pnpm run generate-component-catalog
 */
/* eslint-disable @typescript-eslint/no-explicit-any */

import AlertNotification from '@bees-web/nfa-components-react/lib/atoms/AlertNotification'
import Button from '@bees-web/nfa-components-react/lib/atoms/Button'
import DateDisplay from '@bees-web/nfa-components-react/lib/atoms/DateDisplay'
import Dialog from '@bees-web/nfa-components-react/lib/atoms/Dialog'
import Divider from '@bees-web/nfa-components-react/lib/atoms/Divider'
import Fragment from '@bees-web/nfa-components-react/lib/atoms/Fragment'
import Heading from '@bees-web/nfa-components-react/lib/atoms/Heading'
import Icon from '@bees-web/nfa-components-react/lib/atoms/Icon'
import IconButton from '@bees-web/nfa-components-react/lib/atoms/IconButton'
import Image from '@bees-web/nfa-components-react/lib/atoms/Image'
import Link from '@bees-web/nfa-components-react/lib/atoms/Link'
import List from '@bees-web/nfa-components-react/lib/atoms/List'
import ListItem from '@bees-web/nfa-components-react/lib/atoms/ListItem'
import Loader from '@bees-web/nfa-components-react/lib/atoms/Loader'
import OnLoad from '@bees-web/nfa-components-react/lib/atoms/OnLoad'
import RenderComponent from '@bees-web/nfa-components-react/lib/atoms/RenderComponent'
import Skeleton from '@bees-web/nfa-components-react/lib/atoms/Skeleton'
import Spacer from '@bees-web/nfa-components-react/lib/atoms/Spacer'
import Text from '@bees-web/nfa-components-react/lib/atoms/Text'
import Tooltip from '@bees-web/nfa-components-react/lib/atoms/Tooltip'
import Wrapper from '@bees-web/nfa-components-react/lib/atoms/Wrapper'
import BadgeCounter from '@bees-web/nfa-components-react/lib/molecules/BadgeCounter'
import CardList from '@bees-web/nfa-components-react/lib/molecules/CardList'
import CategoryNavigation from '@bees-web/nfa-components-react/lib/molecules/CategoryNavigation'
import CategoryNavigationDesktop from '@bees-web/nfa-components-react/lib/molecules/CategoryNavigation/CategoryNavigationDesktop'
import NavigationMenu from '@bees-web/nfa-components-react/lib/molecules/CategoryNavigation/CategoryNavigationDesktop/NavigationMenu'
import CategoryNavigationItem from '@bees-web/nfa-components-react/lib/molecules/CategoryNavigation/CategoryNavigationItem'
import CategoryNavigationMobile from '@bees-web/nfa-components-react/lib/molecules/CategoryNavigation/CategoryNavigationMobile'
import Dropdown from '@bees-web/nfa-components-react/lib/molecules/Dropdown'
import GuestFooter from '@bees-web/nfa-components-react/lib/molecules/GuestFooter'
import HeaderDropdown from '@bees-web/nfa-components-react/lib/molecules/HeaderDropdown'
import MinimalDrawer from '@bees-web/nfa-components-react/lib/molecules/MinimalDrawer'
import MyAccount from '@bees-web/nfa-components-react/lib/molecules/MyAccount'
import SearchBar from '@bees-web/nfa-components-react/lib/molecules/SearchBar'
import SideCategoryList from '@bees-web/nfa-components-react/lib/molecules/SideCategoryList'
import DrawerMenu from '@bees-web/nfa-components-react/lib/organisms/DrawerMenu'
import Footer from '@bees-web/nfa-components-react/lib/organisms/Footer'
import LanguageSwitcher from '@bees-web/nfa-components-react/lib/organisms/LanguageSwitcher'
import dynamic from 'next/dynamic'

import type { ComponentType } from 'react'

type LazyComponent = ComponentType<any>

export const componentCatalog: Record<string, ComponentType<any> | LazyComponent> = {
  AlertNotification: AlertNotification as ComponentType<any>,
  Button: Button as ComponentType<any>,
  DateDisplay: DateDisplay as ComponentType<any>,
  Dialog: Dialog as ComponentType<any>,
  Divider: Divider as ComponentType<any>,
  Fragment: Fragment as ComponentType<any>,
  Heading: Heading as ComponentType<any>,
  Icon: Icon as ComponentType<any>,
  IconButton: IconButton as ComponentType<any>,
  Image: Image as ComponentType<any>,
  Link: Link as ComponentType<any>,
  List: List as ComponentType<any>,
  ListItem: ListItem as ComponentType<any>,
  Loader: Loader as ComponentType<any>,
  OnLoad: OnLoad as ComponentType<any>,
  RenderComponent: RenderComponent as ComponentType<any>,
  Skeleton: Skeleton as ComponentType<any>,
  Spacer: Spacer as ComponentType<any>,
  Text: Text as ComponentType<any>,
  Tooltip: Tooltip as ComponentType<any>,
  Wrapper: Wrapper as ComponentType<any>,
  BadgeCounter: BadgeCounter as ComponentType<any>,
  CardList: CardList as ComponentType<any>,
  CategoryNavigation: CategoryNavigation as ComponentType<any>,
  CategoryNavigationDesktop: CategoryNavigationDesktop as ComponentType<any>,
  NavigationMenu: NavigationMenu as ComponentType<any>,
  CategoryNavigationItem: CategoryNavigationItem as ComponentType<any>,
  CategoryNavigationMobile: CategoryNavigationMobile as ComponentType<any>,
  Dropdown: Dropdown as ComponentType<any>,
  GuestFooter: GuestFooter as ComponentType<any>,
  HeaderDropdown: HeaderDropdown as ComponentType<any>,
  MinimalDrawer: MinimalDrawer as ComponentType<any>,
  MyAccount: MyAccount as ComponentType<any>,
  SearchBar: SearchBar as ComponentType<any>,
  SideCategoryList: SideCategoryList as ComponentType<any>,
  DrawerMenu: DrawerMenu as ComponentType<any>,
  Footer: Footer as ComponentType<any>,
  LanguageSwitcher: LanguageSwitcher as ComponentType<any>,
  ActiveFilters: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/ActiveFilters'),
    { ssr: false }
  ),
  AdvancedDateProducts: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/AdvancedDateProducts'),
    { ssr: false }
  ),
  Alert: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Alert'), {
    ssr: false,
  }),
  AlertList: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/AlertList'),
    { ssr: false }
  ),
  AlgoCarousel: dynamic(
    () => import('@bees-web/nfa-components-react/lib/legacy/AlgoCarousel'),
    { ssr: false }
  ),
  BadgeClubBHexagon: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/BadgeClubBHexagon'),
    { ssr: false }
  ),
  BadgeStatus: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/BadgeStatus'),
    { ssr: false }
  ),
  BasicTable: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/BasicTable'),
    { ssr: false }
  ),
  BasicTableCell: dynamic(
    () =>
      import('@bees-web/nfa-components-react/lib/molecules/BasicTable/BasicTableCell'),
    { ssr: false }
  ),
  BasicTableRow: dynamic(
    () =>
      import('@bees-web/nfa-components-react/lib/molecules/BasicTable/BasicTableRow'),
    { ssr: false }
  ),
  BasicTableSection: dynamic(
    () =>
      import(
        '@bees-web/nfa-components-react/lib/molecules/BasicTable/BasicTableSection'
      ),
    { ssr: false }
  ),
  Box: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Box'), {
    ssr: false,
  }),
  BrandSlider: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/BrandSlider'),
    { ssr: false }
  ),
  Breadcrumb: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/Breadcrumb'),
    { ssr: false }
  ),
  Calendar: dynamic(
    () => import('@bees-web/nfa-components-react/lib/legacy/Calendar/Calendar'),
    { ssr: false }
  ),
  Card: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Card'), {
    ssr: false,
  }),
  Carousel: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Carousel'), {
    ssr: false,
  }),
  CartHeader: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/CartHeader'),
    { ssr: false }
  ),
  CartRow: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/CartRow'),
    { ssr: false }
  ),
  CartTable: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/CartTable'),
    { ssr: false }
  ),
  CartTableGroup: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/CartTableGroup'),
    { ssr: false }
  ),
  Checkbox: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Checkbox'), {
    ssr: false,
  }),
  Chip: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Chip'), {
    ssr: false,
  }),
  Collapse: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/Collapse'),
    { ssr: false }
  ),
  ComboProductDetail: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/ComboProductDetail'),
    { ssr: false }
  ),
  CurationGroup: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/CurationGroup'),
    { ssr: false }
  ),
  DateCard: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/DateCard'), {
    ssr: false,
  }),
  DateFilter: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/DateFilter'),
    { ssr: false }
  ),
  DatePicker: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/DatePicker'),
    { ssr: false }
  ),
  DateRange: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/DateRange'),
    { ssr: false }
  ),
  DiscountsTable: dynamic(
    () =>
      import(
        '@bees-web/nfa-components-react/lib/organisms/ProductDetail/PromoRenderer/DiscountsTable'
      ),
    { ssr: false }
  ),
  DownloadBadge: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/DownloadBadge'),
    { ssr: false }
  ),
  DragAndDrop: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/DragAndDrop'),
    { ssr: false }
  ),
  Drawer: dynamic(() => import('@bees-web/nfa-components-react/lib/organisms/Drawer'), {
    ssr: false,
  }),
  DropdownButton: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/DropdownButton'),
    { ssr: false }
  ),
  Embed: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Embed'), {
    ssr: false,
  }),
  EnhancedOrderSummary: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/EnhancedOrderSummary'),
    { ssr: false }
  ),
  ErrorListGroup: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/ErrorListGroup'),
    { ssr: false }
  ),
  ErrorMessage: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/ErrorMessage'),
    { ssr: false }
  ),
  ErrorsList: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/ErrorsList'),
    { ssr: false }
  ),
  FilterByCheckbox: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/FilterByCheckbox'),
    { ssr: false }
  ),
  FilterByInput: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/FilterByInput'),
    { ssr: false }
  ),
  Filters: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/Filters'),
    { ssr: false }
  ),
  FiltersDesktop: dynamic(
    () => import('@bees-web/nfa-components-react/lib/deprecated/FiltersDesktop'),
    { ssr: false }
  ),
  FreeGoodDetails: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/FreeGoodDetails'),
    { ssr: false }
  ),
  FreeGoodProductCard: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/FreeGoodProductCard'),
    { ssr: false }
  ),
  FreeGoodsModal: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/FreeGoodsModal'),
    { ssr: false }
  ),
  GuestHeader: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/GuestHeader'),
    { ssr: false }
  ),
  HeaderSwitcher: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/HeaderSwitcher'),
    { ssr: false }
  ),
  HintText: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/HintText'), {
    ssr: false,
  }),
  IFrame: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/IFrame'), {
    ssr: false,
  }),
  Input: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Input'), {
    ssr: false,
  }),
  ItemCollapse: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/ItemCollapse'),
    { ssr: false }
  ),
  ItemOrder: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/ItemOrder'),
    { ssr: false }
  ),
  Label: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Label'), {
    ssr: false,
  }),
  Legend: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Legend'), {
    ssr: false,
  }),
  ListItemLegacy: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/ListItemLegacy'),
    { ssr: false }
  ),
  Menu: dynamic(() => import('@bees-web/nfa-components-react/lib/molecules/Menu'), {
    ssr: false,
  }),
  MenuItem: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/MenuItem'),
    { ssr: false }
  ),
  MessageBox: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/MessageBox'),
    { ssr: false }
  ),
  Modal: dynamic(() => import('@bees-web/nfa-components-react/lib/molecules/Modal'), {
    ssr: false,
  }),
  Navigation: dynamic(
    () => import('@bees-web/nfa-components-react/lib/deprecated/Navigation'),
    { ssr: false }
  ),
  NavigationCard: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/NavigationCard'),
    { ssr: false }
  ),
  NewAddForm: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/NewAddForm'),
    { ssr: false }
  ),
  NumberDisplay: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/NumberDisplay'),
    { ssr: false }
  ),
  OptionSelect: dynamic(
    () =>
      import('@bees-web/nfa-components-react/lib/molecules/OptionSelect/OptionSelect'),
    { ssr: false }
  ),
  OrderCheckout: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/OrderCheckout'),
    { ssr: false }
  ),
  OrderCollapse: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/OrderCollapse'),
    { ssr: false }
  ),
  OrderConfirmationGroup: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/OrderConfirmationGroup'),
    { ssr: false }
  ),
  OrderDetailsEditModeSuccess: dynamic(
    () =>
      import(
        '@bees-web/nfa-components-react/lib/organisms/OrderDetailsEditModeSuccess'
      ),
    { ssr: false }
  ),
  OrderDetailsEditModeTable: dynamic(
    () =>
      import('@bees-web/nfa-components-react/lib/organisms/OrderDetailsEditModeTable'),
    { ssr: false }
  ),
  OrderDetailsTable: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/OrderDetailsTable'),
    { ssr: false }
  ),
  OrderStatusCard: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/OrderStatusCard'),
    { ssr: false }
  ),
  OrderSummary: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/OrderSummary'),
    { ssr: false }
  ),
  OrderSummaryGroup: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/OrderSummaryGroup'),
    { ssr: false }
  ),
  OrderTrackingTableBody: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/OrderTrackingTableBody'),
    { ssr: false }
  ),
  PageTitle: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/PageTitle'),
    { ssr: false }
  ),
  Pagination: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/Pagination'),
    { ssr: false }
  ),
  PaginationPill: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/PaginationPill'),
    { ssr: false }
  ),
  PalletInformation: dynamic(
    () =>
      import(
        '@bees-web/nfa-components-react/lib/molecules/PalletInformation/PalletInformation'
      ),
    { ssr: false }
  ),
  ParlistSummaryAddToCart: dynamic(
    () =>
      import('@bees-web/nfa-components-react/lib/organisms/ParlistSummaryAddToCart'),
    { ssr: false }
  ),
  ParlistTable: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/ParlistTable'),
    { ssr: false }
  ),
  PartnerSlider: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/PartnerSlider'),
    { ssr: false }
  ),
  PaymentMethod: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/PaymentMethod'),
    { ssr: false }
  ),
  PayWithPoints: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/PayWithPoints'),
    { ssr: false }
  ),
  PinInsightsEmbed: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/PinInsightsEmbed'),
    { ssr: false }
  ),
  PlpProductTable: dynamic(
    () =>
      import(
        '@bees-web/nfa-components-react/lib/organisms/ProductCard/variants/table/ProductCardTableLayout'
      ),
    { ssr: false }
  ),
  PreviewCard: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/PreviewCard'),
    { ssr: false }
  ),
  PrimaryOfferBadge: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/PrimaryOfferBadge'),
    { ssr: false }
  ),
  ProductCard: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/ProductCard'),
    { ssr: false }
  ),
  ProductDetail: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/ProductDetail'),
    { ssr: false }
  ),
  ProductOrderSubtotalBar: dynamic(
    () =>
      import('@bees-web/nfa-components-react/lib/molecules/ProductOrderSubtotalBar'),
    { ssr: false }
  ),
  ProgressBar: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/ProgressBar'),
    { ssr: false }
  ),
  PromoCode: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/InputPromoCode'),
    { ssr: false }
  ),
  Radio: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Radio'), {
    ssr: false,
  }),
  RadioWithButton: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/RadioWithButton'),
    { ssr: false }
  ),
  RecommendationCards: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/RecommendationCards'),
    { ssr: false }
  ),
  ResultsInfo: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/ResultsInfo'),
    { ssr: false }
  ),
  SearchCheckbox: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/SearchCheckbox'),
    { ssr: false }
  ),
  SectionName: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/SectionName'),
    { ssr: false }
  ),
  Select: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Select'), {
    ssr: false,
  }),
  ShopListRow: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/ShopListRow'),
    { ssr: false }
  ),
  ShopListTable: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/ShopListTable'),
    { ssr: false }
  ),
  ShowMore: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/ShowMore'), {
    ssr: false,
  }),
  SidebarMenu: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/SidebarMenu'),
    { ssr: false }
  ),
  SkeletonProducts: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/SkeletonProducts'),
    { ssr: false }
  ),
  StarRating: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/StarRating'),
    { ssr: false }
  ),
  SummaryParlist: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/SummaryParlist'),
    { ssr: false }
  ),
  Survey: dynamic(() => import('@bees-web/nfa-components-react/lib/molecules/Survey'), {
    ssr: false,
  }),
  Tab: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Tab'), {
    ssr: false,
  }),
  Table: dynamic(() => import('@bees-web/nfa-components-react/lib/molecules/Table'), {
    ssr: false,
  }),
  TableCell: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/Table/TableCell'),
    { ssr: false }
  ),
  TableRow: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/Table/TableRow'),
    { ssr: false }
  ),
  TableSection: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/Table/TableSection'),
    { ssr: false }
  ),
  TextArea: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/TextArea'), {
    ssr: false,
  }),
  TextInput: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/TextInput/TextInput'),
    { ssr: false }
  ),
  ThemeProvider: dynamic(
    () => import('@bees-web/nfa-components-react/lib/theming/ThemeProvider'),
    { ssr: false }
  ),
  TimeBadge: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/TimeBadge'),
    { ssr: false }
  ),
  Toggle: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Toggle'), {
    ssr: false,
  }),
  ToggleRow: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/ToggleRow'),
    { ssr: false }
  ),
  TopDealsCard: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/TopDealsCard'),
    { ssr: false }
  ),
  TotalProducts: dynamic(
    () => import('@bees-web/nfa-components-react/lib/organisms/TotalProducts'),
    { ssr: false }
  ),
  TrayMixAndMatch: dynamic(
    () =>
      import(
        '@bees-web/nfa-components-react/lib/molecules/CartRow/components/InfoBlock/components/InfoMixAndMatch/TrayMixAndMatch'
      ),
    { ssr: false }
  ),
  Uploader: dynamic(() => import('@bees-web/nfa-components-react/lib/atoms/Uploader'), {
    ssr: false,
  }),
  UploaderDragAndDrop: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/UploaderDragAndDrop'),
    { ssr: false }
  ),
  UploadSummaryCard: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/UploadSummaryCard'),
    { ssr: false }
  ),
  VideoComponent: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/VideoComponent'),
    { ssr: false }
  ),
  WeekCalendar: dynamic(
    () => import('@bees-web/nfa-components-react/lib/molecules/WeekCalendar'),
    { ssr: false }
  ),
  WizardSteps: dynamic(
    () => import('@bees-web/nfa-components-react/lib/atoms/WizardSteps'),
    { ssr: false }
  ),
}
